import { useBKJComboBoxAsyncContext } from './src/BKJComboBoxAsync.context.js';
export const itemToString = function (option) {
    return typeof option?.label === 'string' ? option?.label : '';
};
export const optionsVariant = 'Search';
/**
 * WEB-4815 / FR-011a: resolves the results-count announcement text from
 * either a function (called with `count`), a template string (with `{N}`
 * substituted), or the English singular/plural default.
 */
export function resolveResultsCountLabel(label, count) {
    if (typeof label === 'function')
        return label(count);
    if (typeof label === 'string')
        return label.replace('{N}', String(count));
    if (count === 1)
        return '1 result found';
    return `${count} results found`;
}
export function getPopperOptions() {
    return {
        modifiers: [
            {
                name: 'offset',
                enabled: true,
                phase: 'main',
                effect: ({ state: { elements: { reference }, }, instance, }) => {
                    const RO_PROP = '__popperjsRO__';
                    reference[RO_PROP] = new ResizeObserver(() => {
                        instance.update();
                    });
                    reference[RO_PROP].observe(reference);
                    const observer = new ResizeObserver(() => instance.update());
                    observer.observe(reference);
                    return () => {
                        reference[RO_PROP].disconnect();
                        delete reference[RO_PROP];
                    };
                },
            },
            {
                name: 'sameWidth',
                enabled: true,
                phase: 'beforeWrite',
                requires: ['computeStyles'],
                fn({ state }) {
                    if (!state.styles['popper'])
                        return void 0;
                    state.styles['popper'].minWidth = `${state.rects.reference.width}px`;
                    state.styles['popper'].maxWidth = `${state.rects.reference.width}px`;
                    return void 0;
                },
                options: {
                    adaptive: true,
                    gpuAcceleration: true,
                },
                effect({ state }) {
                    if (!state.elements.reference['offsetWidth'])
                        return void 0;
                    state.elements.popper.style.minWidth = `${state.elements.reference.offsetWidth}px`;
                    state.elements.popper.style.maxWidth = `${state.elements.reference.offsetWidth}px`;
                    return void 0;
                },
            },
        ],
    };
}
export const useRightIconProps = (action, disabled) => {
    const { searchValue, reset, isOpen, anchorElement, openMenu, closeMenu } = useBKJComboBoxAsyncContext();
    switch (action) {
        case 'ClearInputValue':
            if (searchValue)
                return { iconName: 'CloseBold', onClick: reset };
            return undefined;
        case 'OpenToggle':
            return {
                isOpen,
                iconName: 'ArrowDown',
                onClick: disabled
                    ? undefined
                    : () => {
                        if (!isOpen) {
                            anchorElement?.focus();
                            openMenu();
                        }
                        else {
                            closeMenu();
                        }
                    },
            };
        default:
            return undefined;
    }
};
//# sourceMappingURL=BKJComboBoxAsync.utils.js.map